import { Pago, Renta, RentaTarifa, TiposAlojamientos, TiposPagos } from 'src/gql/schema'
import EstanciaDetail from '../EstanciaDetail/EstanciaDetail'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailIcon from 'src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import { useDate } from 'src/shared/hooks/useDate'
import { formatTipoPago } from 'src/shared/helpers/formatTipoPago'
import { useFormatDate } from 'src/shared/hooks/useFormatDate'

const EstanciaDetailList = ({ tarifas, pago, tipoAlojamiento }: { tarifas: RentaTarifa[], ultima_renta?: Renta, pago?: Pago, tipoAlojamiento: TiposAlojamientos }) => {
    const { UTCStringToLocalDate } = useDate()
    const { formatCustomDate } = useFormatDate()

    return (<>
        <Detail color='var(--white)'>
            <DetailIcon name='HotelFilled' />
            <DetailContent>
                <DetailRow>
                    <DetailText type='normal'>
                        Estancia y tarifas
                    </DetailText>
                </DetailRow>
                {Object.values(
                    tarifas.reduce<Record<string, RentaTarifa[]>>((acc, t) => {
                        const key = `${t.tarifa_id}_${t.subtotales?.precio_unitario ?? ''}`
                        if (!acc[key]) acc[key] = []
                        acc[key].push(t)
                        return acc
                    }, {})
                ).map((group, index) => (
                    <EstanciaDetail key={index} tarifas={group} tipo_hospedaje={tipoAlojamiento} />
                ))}

                {
                    <DetailRow>
                        <DetailText type='bold'>
                            {formatCustomDate(UTCStringToLocalDate(pago?.fecha_pago), "MMM, DD YYYY, hh:mm A")}
                        </DetailText>
                        <DetailText type='bold' textAlign='right'>
                            {
                                (pago?.detalles_pago?.reduce<string[]>((acc, dp) => {
                                    const hasRef = [TiposPagos.Amex, TiposPagos.VisaOMastercard].includes(dp.tipo_pago) || dp.tipo_pago === TiposPagos.DepositoOTransferencia
                                    const label = [TiposPagos.Amex, TiposPagos.VisaOMastercard].includes(dp.tipo_pago)
                                        ? (dp.ultimos_digitos ? `*${dp.ultimos_digitos}` : dp.numero_referencia ? `*${dp.numero_referencia}` : "")
                                        : formatTipoPago(dp.tipo_pago)
                                    if (!hasRef && acc.includes(label)) return acc
                                    return [...acc, label]
                                }, []) || []).join(" ")
                            }
                        </DetailText>
                    </DetailRow>
                }
            </DetailContent>
        </Detail>

    </>
    )
}

export default EstanciaDetailList